import { Button, Col, Row } from "reactstrap";
import Drawer from "../../../assets/vfx/drawer/drawer";
import DisplayData from "../../common/DisplayData/DisplayData";
import TabComponent from "../../common/Tabs/tabs";
import { ClaimHelper, FormatHelper } from "../../../assets/utils/helpers";
import { ConfirmationDialog } from "../../../assets/types";
import { SectionContainer } from "../section/sectionContainer";
import { QuestionContainer } from "../question/questionContainer";
import { Constants } from "../../../assets/utils/lib/constants";
import { DeviceQuestionnaireChoiceDto, FormDto, QuestionDto, QuestionnaireRequestPushNotificationDto } from "../../../services/dto";
import { QuestionnaireFormLookupProps } from "./questionnaireForm";
import { QuestionnaireResponseContainer } from "../questionnaireResponse/questionnaireResponseContainer";
import { QuestionnaireNotificationType, QuestionnaireType } from "./questionnaireContainer";
import { QuestionnairePollQuestionResponse, QuestionnairePollQuestion } from "./questionnairePollQuestion";
import React from "react";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import { PushNotificationService } from "../../herenow/pushNotification/pushNotificationService";
import { PushNotificationForm } from "../../herenow/pushNotification/pushNotificationForm";
import { useSnackbar } from "../../../assets/vfx/snackbar/vfxSnackbarContext";
import { MessageSeverity } from "../../../assets/utils/lib/messageSeverity";
import { useControlStyles } from "../../../assets/layouts";
import { roles } from "../../../assets/configuration";
import moment from 'moment';

interface QuestionnaireFormViewProps {
    data: FormDto | undefined;
    questionnaireResponseData?: DeviceQuestionnaireChoiceDto[] | undefined;
    show: boolean;
    lookups: QuestionnaireFormLookupProps | undefined;
    onHide: () => void;
    onEdit: () => void;
    onDeactivate: () => void;
    questionnaireType?: string | undefined;
    question?: QuestionDto | undefined;
    onQuestionEdit: () => void;
}

export const QuestionnaireView = (props: QuestionnaireFormViewProps) => {
    const { showSnackbar } = useSnackbar();
    const styles = useControlStyles();
    const [showPushForm, setShowPushForm] = React.useState(false);
    const isPollView = props.questionnaireType && props.questionnaireType == QuestionnaireType.Poll.toLowerCase() || props.data?.typeId == QuestionnaireType.Poll.toLowerCase();
    const isFeedbackView = props.questionnaireType && props.questionnaireType == QuestionnaireType.Feedback.toLowerCase() || props.data?.typeId == QuestionnaireType.Feedback.toLowerCase();
    const isSurveyView = props.questionnaireType && props.questionnaireType == QuestionnaireType.Survey.toLowerCase() || props.data?.typeId == QuestionnaireType.Survey.toLowerCase();
    const isSystemAdmin = ClaimHelper.hasRole([roles.SystemAdmin]);

    const type = props?.lookups?.questionnaireLookupValueType.find(
        (x) => x.value === props?.data?.typeId
    )?.display;

    const communityName = props?.lookups?.community.find(
        (x) => x.value === props?.data?.communityId
    )?.display;

    const tagName = props?.lookups?.tags.find(
        (x) => x.value === props?.data?.tagId
    )?.display;

    const questionnaireActiveDuration = props?.data?.activeFromDate
        ? FormatHelper.formatDate(props?.data?.activeToDate)
            ? `${FormatHelper.formatDate(props?.data?.activeFromDate)}  to  ${FormatHelper.formatDate(props?.data?.activeToDate)}`
            : `${FormatHelper.formatDate(props?.data?.activeFromDate)}`
        : '';

    const pushLookups = React.useMemo(() => {
        const communities: DropdownOption[] = props.lookups?.community ?? [];
        const userCommunities: DropdownOption[] = props.lookups?.userCommunities ?? [];
        const notificationType: DropdownOption[] = props.lookups?.notificationType ?? [];
        const pageLink: DropdownOption[] = props.lookups?.pageLink ?? [];
        return { communities, userCommunities, notificationType, pageLink };
    }, [props.lookups]);

    const handleSaveQuestionnairePush = async (dto: QuestionnaireRequestPushNotificationDto) => {
        await PushNotificationService.saveQuestionnairePushNotification(dto);
        showSnackbar("Push Notification scheduled.", MessageSeverity.Success);
    };

    const linkDefaults = React.useMemo(() => {
        const force = isPollView || isFeedbackView;
        const name = isPollView ? "Poll" : isFeedbackView ? "Feedback" : "Survey";
        return { force, name };
    }, [isPollView, isFeedbackView, isSurveyView]);

    const today: Date = new Date();

    const isPastActiveToDate: boolean = React.useMemo(() => {
        if (!props.data?.activeToDate) return false;
        const to: Date = new Date(props.data.activeToDate as any);
        const endOfDay: Date = new Date(to);
        endOfDay.setHours(23, 59, 59, 999);
        return Date.now() > endOfDay.getTime();
    }, [props.data?.activeToDate]);

    const canShowSendPush: boolean = (isPollView || isFeedbackView || isSurveyView) && !!props.data?.id && !(isPastActiveToDate);
    const notificationTypeId: string = props.questionnaireType == QuestionnaireType.Poll.toLowerCase() ? QuestionnaireNotificationType.poll :
        props.questionnaireType == QuestionnaireType.Feedback.toLowerCase() ? QuestionnaireNotificationType.feedback : QuestionnaireNotificationType.survey;
    const title: string = isPollView ? "View Poll" : isFeedbackView ? "View Feedback" : "View Survey";
    return (
        <>
            <Drawer.View
                className="w-90"
                show={props.show}
                backdrop={true}
                placement="end"
                scroll={true}
                onHide={() => props.onHide()}
                onEdit={props.onEdit}
                title={title}
                onDeactivate={props.onDeactivate}
                showDeactivateOnHeader={true}
                modalDialogType="Deactivate"
                modalDialogProps={new ConfirmationDialog().get(
                    props.onDeactivate,
                    "Deactivate",
                    { Name: Constants.emptyString }
                )}
            >
                <Row>
                    {props.data?.name && <Col md={4}>
                        <DisplayData text="Title" importedData={props.data?.name} />
                    </Col>}
                    <Col md={4}>
                        <DisplayData text="Community Name" importedData={communityName} />
                    </Col>
                    {!(isPollView || isFeedbackView) && <Col md={4}>
                        <DisplayData text="Type" importedData={type} />
                    </Col>
                    }
                    <Col md={4}>
                        <DisplayData
                            text="Active From"
                            importedData={
                                questionnaireActiveDuration
                            }
                        />
                    </Col>
                </Row>
                <Row>
                </Row>
                {props.data?.id && (
                    <PushNotificationForm
                        show={showPushForm}
                        onHide={() => setShowPushForm(false)}
                        onSave={() => { }}
                        onSaveQuestionnaire={handleSaveQuestionnairePush}
                        submitToQuestionnaireApi
                        questionnaireId={props.data.id}
                        lookups={pushLookups}
                        communityId={props.data.communityId}
                        disableCommunity={true}
                        notificationTypeId={notificationTypeId}
                        loading={false}
                        data={{
                            title: props.data?.name,
                            message: isPollView || isFeedbackView ? props.data?.pollQuestion?.description : Constants.emptyString,
                            notificationTypeId: notificationTypeId,
                            id: Constants.emptyGuid,
                            fromCommunityId: props.data.communityId,
                            priority: 100,
                            sendToCommunityIds: [props.data.communityId],
                            sentDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSSSZ") as any,
                            scheduledTimeUtc: FormatHelper.formatDateTimeForDatePicker(today) as any,
                            actionLabel: title,
                            quickReply: false,
                            geometry: []
                        }}
                        forceLinkToPage={linkDefaults.force}
                        lockPageLink={linkDefaults.force}
                        defaultPageLinkName="Poll"
                        disableCommunitytoSend={true}
                    />
                )}
                <Row>
                    <Col md={6}>
                        {isPollView && props.data?.pollQuestion && props.questionnaireResponseData &&
                            <QuestionnairePollQuestionResponse questionnaireResponse={props.questionnaireResponseData} />
                        }
                        {
                            isFeedbackView && props.data?.pollQuestion &&
                            <QuestionnairePollQuestion question={props.data.pollQuestion} />
                        }
                    </Col>
                    <Col md={6}>
                        {canShowSendPush && (
                            <Row className="mt-3 text-end">
                                <Col>
                                    <Button color="primary" size="sm" style={styles.button} onClick={() => setShowPushForm(true)}>
                                        Send Push Notification
                                    </Button>
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
                {isFeedbackView && <TabComponent
                    name="Forms"
                    idName="Questionnaire"
                    eventKeys={[
                        "Responses-panel",
                    ]}
                    tabPanes={[
                        <QuestionnaireResponseContainer questionnaireId={props.data?.id} />,
                    ]}
                    tabNames={["Responses"]}
                />}

                {!(isPollView || isFeedbackView) && <TabComponent
                    name="Forms"
                    idName="Questionnaire"
                    eventKeys={[
                        "Section-panel",
                        "Questions-panel",
                        "Responses-panel",
                    ]}
                    tabPanes={[
                        <SectionContainer questionnaireId={props.data?.id} questionnaireType={props.data?.typeId} />,
                        <QuestionContainer questionnaireId={props.data?.id} questionnaireType={props.data?.typeId} />,
                        <QuestionnaireResponseContainer questionnaireId={props.data?.id} />,
                    ]}
                    tabNames={["Section", "Questions", "Responses"]}
                />}

            </Drawer.View>
        </>
    );
};
